
































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import HomeNavigationStore from '../Store/HomeNavigationStore'

@Component
export default class ComponentHomeLeftNavBar extends Vue {
  get getHomeNavigationStore() {
    return getModule(HomeNavigationStore, this.$store)
  }

  get drawer() {
    return !!this.getHomeNavigationStore.navigationDrawer
  }

  items: any[] = [
    {
      title: 'Agendamento médico',
      icon: 'mdi-medical-bag',
      url: '/agendamento-medico',
      view: 'agendamento-medico',
    },
    {
      title: 'Calculadora',
      icon: 'mdi-calculator',
      url: '/calculadora',
      view: 'calculadora',
    },
    {
      title: 'Produção',
      icon: 'add_box',
      url: '/producao',
      view: 'producao',
    },
    {
      title: 'Recebimento',
      icon: 'receipt',
      url: '/recebimento',
      view: 'recebimento',
    },
    {
      title: 'Relatório',
      icon: 'mdi-chart-bar',
      url: '/relatorio',
      view: 'relatorio',
    },
  ]

  allowedItems: string[] = []

  get menu() {
    return this.items.filter((e: any) => this.allowedItems.includes(e.view))
  }

  created() {
    this.allowedItems = Object.values(this.$user.profile.pageAuthorized)
  }

  windowWidth: number = 0

  get mobileBreakpoint() {
    return this.windowWidth < 768
  }

  getWindowWidth() {
    this.windowWidth = document.documentElement.clientWidth
  }

  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
    })
  }

  updated() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
    })
  }
}
